/**
 * Frontend formatting utilities
 */

export function formatCurrency(value: number, currency = 'BRL'): string {
  return new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency,
    minimumFractionDigits: 2,
  }).format(value);
}

export function formatPercent(value: number, showSign = true): string {
  const sign = showSign && value > 0 ? '+' : '';
  return `${sign}${value.toFixed(2)}%`;
}

export function formatDate(date: string | Date): string {
  const d = typeof date === 'string' ? new Date(date + 'T12:00:00') : date;
  return new Intl.DateTimeFormat('pt-BR').format(d);
}

export function formatShortDate(date: string | Date): string {
  const d = typeof date === 'string' ? new Date(date + 'T12:00:00') : date;
  return new Intl.DateTimeFormat('pt-BR', { month: 'short', day: 'numeric' }).format(d);
}

export function formatMonthYear(date: string | Date): string {
  const d = typeof date === 'string' ? new Date(date + '-01T12:00:00') : date;
  return new Intl.DateTimeFormat('pt-BR', { month: 'long', year: 'numeric' }).format(d);
}

export function formatNumber(value: number, decimals = 2): string {
  return new Intl.NumberFormat('pt-BR', {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  }).format(value);
}

export function formatQuantity(value: number): string {
  if (value % 1 === 0) return value.toLocaleString('pt-BR');
  return value.toFixed(8).replace(/\.?0+$/, '');
}

export function hideCurrency(value: number, isVisible: boolean, currency = 'BRL'): string {
  return isVisible ? formatCurrency(value, currency) : 'R$ •••••';
}

export function hidePercent(value: number, isVisible: boolean, showSign = true): string {
  return isVisible ? formatPercent(value, showSign) : '•••%';
}

export function isPositive(value: number): boolean {
  return value > 0;
}

export function gainLossClass(value: number): string {
  if (value > 0) return 'text-success-500';
  if (value < 0) return 'text-danger-500';
  return 'text-white/60';
}
